import { css } from 'styled-components';

const STATIC_FILES_BASE_URL =
  process.env.STATIC_FILES_BASE_URL ??
  'https://prod-static-files-bucket-qe7n6zmsazm7.s3.eu-west-1.amazonaws.com';

/**
 *  Lato @font-face declarations taken from here:
 *  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');
 *  inlined here because CSS @import rules must appear before other rules in the same stylesheet
 */
export const fontFaces = css`
  /* latin-ext */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v25/S6uyw4BMUTPHjxAwXiWtFCfQ7A.woff2) format('woff2');
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308,
      U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113,
      U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v25/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
      U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v25/S6u9w4BMUTPHh6UVSwaPGQ3q5d0N7w.woff2)
      format('woff2');
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308,
      U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113,
      U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v25/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
      U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'NOTHS Suisse Neue';
    src: url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_light.woff2')
        format('woff2'),
      url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_light.woff')
        format('woff');
    font-style: normal;
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: 'NOTHS Suisse Neue';
    src: url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_medium.woff2')
        format('woff2'),
      url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_medium.woff')
        format('woff');
    font-style: normal;
    font-weight: 500;
    font-display: swap;
  }
`;
